export const calculateTimeFromRelativePosition = (
  relativeX: number,
  rectWidth: number,
  duration: number,
) => {
  if (duration === 0) return 0;
  const percentage = Math.max(0, Math.min(1, relativeX / rectWidth));
  return percentage * duration;
};

export const getClampedRelativeXFromClientX = (
  clientX: number,
  rect: DOMRect,
) => {
  if (clientX < rect.left) {
    // Cursor is to the left of the scrubber
    return 0;
  } else if (clientX > rect.right) {
    // Cursor is to the right of the scrubber
    return rect.width;
  } else {
    // Cursor is within the scrubber
    return clientX - rect.left;
  }
};
